export class RecoveryCodesAlreadyExistError extends Error {
  constructor() {
    super('Recovery codes already exist for this user.')
    Object.setPrototypeOf(this, RecoveryCodesAlreadyExistError.prototype)
  }
}
